export default {
  BROADLY:      'Other',
  GOOGLE:       'Google',
  FACEBOOK:     'Facebook',
  TRIP_ADVISOR: 'TripAdvisor'
};
